// extracted by mini-css-extract-plugin
export default {"root":"ProductCategoryList_root__u16-p","container":"ProductCategoryList_container__8zi25"};